<template>
    <div >
      <div class="row">
        <div class="col-10 d-flex" style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%">
          <span class="textSize m-2" style="font-weight: 600;">continuar con producción del producto</span>
        </div>
      </div>

      <div class="m-4">
      <div>
        <p>Ingresa los comentarios del por qué se seguirá con la producción del producto.</p>
      </div>

        <div class="mt-4" style="width: 80%;">
          <b-form-group >
              <label for="nombres">Observaciones<span style="color: red">*</span></label>
              <b-form-textarea
                  style="resize:both; height: 60px;  font-size: .9em;"
                  id="textarea"
                  placeholder="Ingresa las observaciones"
                  rows="3"
                  max-rows="6"
                  v-model="datosRechazo.observaciones"
                  class="w-100"
              ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="m-5">
          <div class="d-flex justify-content-center  " >
              <div class=" d-flex justify-content-between" style="width: 40%; position: absolute; bottom: 20px;">
                  <b-button :disabled="datosRechazo.observaciones === null || datosRechazo.observaciones === '' " pill variant="primary" @click="guardarRechazo()" style="background: #0155A7; color: aliceblue">
                      Guardar
                  </b-button>
                  <b-spinner v-if="guardando" variant="info" small/>
                  <b-button pill variant="secondary" @click="cerrarModalRechazos()">Cancelar</b-button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "ModalContinuarProduccion",
    components: {},
    props: {
      idODT: Number,
      idOdtRechazo: Number,
      producto: String,
    },
    data: () => ({
      datosRechazo: {
        observaciones: null
      },
      guardando: false,
    }),
    created() {},
    methods: {
      guardarRechazo(){
        this.$swal({
          title: 'Continuar con la producción de la ODT',
          text: 'Se notificará al laboratorio que continue con la elaboración del producto "'+this.producto+'", ¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            //aqui se guarda
            this.guardando = true;
            this.datosRechazo.idOdtRechazo = this.idOdtRechazo;
            const params = {
              idSolicitud: this.$route.params.idSolicitud,
              idEtapa: this.$route.params.idEtapa,
              retorno: false,
              rechazo: false,
              continua: true,
              idOdtLaboratorio: this.$route.params.idOdt,
              datosRechazo: this.datosRechazo,
              idAccion: this.$route.params.idEtapa === 109 ? 54 : 56,
            }
            this.$http.post(this.$api + "labs/odt/siguienteEtapa", params).then(response => {
              if (response.data.data) {
                this.guardando = false;
                this.$swal({
                  title: 'Producción del producto',
                  text: 'Se continuará con la producción del producto y se notificó al laboratorio',
                  icon: 'success',
                  showCancelButton: true,
                  showConfirmButton: false,
                  cancelButtonText: 'Cerrar'
                }).then((result) => {
                  if (result.isDismissed) {
                    this.$emit("cerrarModalRechazos");
                    window.history.back();
                  }
                });
              }
            }).catch((err) => {
              this.guardando = false;
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrió un error",
              });
              console.info(err)
            });
          }
        });
      },

      cerrarModalRechazos(){
        this.$emit('cerrarModalRechazos');
      },
  
    }
  }
  </script>
  <style scoped>
  
  </style>
  